import {CampaignType} from 'common/src/modules/campaigns/campaigns.types';
import {TemplateType} from 'common/src/modules/creativeTemplates/creativeTemplates.types';

/**
 * Returns the template types that are valid for creatives in the given campaign type.
 * Mirrors the logic from getGalleryType (campaigns domain) for use in common.
 */
function getCampaignTemplateTypes(campaignType: CampaignType): TemplateType[] {
  switch (campaignType) {
    case CampaignType.VideoAds:
    case CampaignType.YoutubeVideoAds:
      return [TemplateType.VideoAds];

    case CampaignType.DynamicBanners:
      return [TemplateType.DisplayAds, TemplateType.ExternalAds, TemplateType.ImageAds];

    case CampaignType.InBannerVideoAds:
      return [
        TemplateType.InBannerVideoAds,
        TemplateType.ExternalAds,
        TemplateType.DisplayAds,
        TemplateType.ImageAds,
      ];

    case CampaignType.NativeAds:
      return [TemplateType.ImageAds];

    case CampaignType.InteractiveVideoAds:
      return [TemplateType.InteractiveVideoAds, TemplateType.VideoAds];

    case CampaignType.TikTokAds:
    case CampaignType.SnapchatAds:
    case CampaignType.LinkedInAds:
    case CampaignType.FacebookVideoAds:
      return [TemplateType.VideoAds, TemplateType.ImageAds];

    case CampaignType.ThirdPartyAdTracking:
      return [];

    case CampaignType.DoohImageAd:
      return [TemplateType.ImageAds];

    default:
      return [];
  }
}

export default getCampaignTemplateTypes;
